<ion-app>
  <ion-router-outlet [class.hidden]="isServerStatusDown || this.myService.isVersionObsoleta"></ion-router-outlet>
  @if (isServerStatusDown) {
    <div class="status-main-container">
      <div class="status-content">
        <img class="status-logo" src="../../../assets/imgs/logo.png" alt="Logo" />
        <h2 class="status-title">{{'alertAppInAggiornamento' | tr}}</h2>
        <p class="status-message">{{'alertAppInAggiornamentoMess' | tr}}</p>
        <img class="status-loader" src="../../../assets/imgs/status-loader.gif" alt="Loading" />
        <ion-button size="small" (click)="this.checkServerStatus()">{{'riprovaLabel' | tr}}</ion-button>
      </div>
    </div>
  }

  <!-- Blocco versione obsoleta: full-screen, non chiudibile, unica azione = aggiornare dallo store -->
  @if (!isServerStatusDown && this.myService.isVersionObsoleta) {
    <div class="status-main-container">
      <div class="status-content">
        <img class="status-logo" src="../../../assets/imgs/logo.png" alt="Logo" />
        <h2 class="status-title">{{'alertAppObsoleta' | tr}}</h2>
        <p class="status-message">{{'alertAppObsoletaMess' | tr}}</p>
        <ion-button size="small" (click)="openAppStore()">{{'appUpdateLabel' | tr}}</ion-button>
      </div>
    </div>
  }
</ion-app>